export default (function (value) {
  return value.length === 0;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isEmpty.js
// module id = 690
// module chunks = 1